import React from "react";
import "./rumah.scss";
import Slider from "react-slick";
import Produk1 from "./Produk1/Produk1.jsx";
import Produk2 from "./Produk2/Produk2.jsx";
import Produk3 from "./Produk3/Produk3.jsx";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const rumah = () => {
  return (
    <div id="rumah" className="rumah">
      <div className="judul-residential">CLUSTERS IN KOTA HARAPAN INDAH</div>
      <div>
        <div className="Judul"></div>
        <div className="rumah-card">
          <Produk1 />
          <Produk2 />
          <Produk3 />
        </div>
      </div>
    </div>
  );
};

export default rumah;
